import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Cell, ResponsiveContainer, Tooltip, LabelList,
} from 'recharts';
import { useChartColors } from '../../hooks';
import './StatusBars.css';

export interface StatusBar {
  key: string;
  label: string;
  value: number;
  color: string;
}

interface StatusBarsProps {
  bars: StatusBar[];
  total: number;
}

interface TooltipPayload { payload: StatusBar; }

const BarTooltip: React.FC<{ active?: boolean; payload?: TooltipPayload[]; total: number }> = ({ active, payload, total }) => {
  if (!active || !payload || payload.length === 0) return null;
  const b = payload[0].payload;
  const pct = total > 0 ? (b.value / total) * 100 : 0;
  const pctLabel = pct > 0 && pct < 1 ? '<1%' : `${Math.round(pct)}%`;
  return (
    <div className="statusbars-tooltip">
      <span className="statusbars-tt-dot" style={{ background: b.color }} />
      <span>{b.label}</span>
      <strong>{b.value}</strong>
      <em>{pctLabel}</em>
    </div>
  );
};

export const StatusBars: React.FC<StatusBarsProps> = ({ bars, total }) => {
  const colors = useChartColors();

  return (
    <div className="statusbars-wrap">
      <ResponsiveContainer width="100%" height={Math.max(bars.length * 40, 160)}>
        <BarChart data={bars} layout="vertical" margin={{ top: 4, right: 36, bottom: 4, left: 4 }}>
          <XAxis type="number" hide />
          <YAxis
            type="category"
            dataKey="label"
            width={92}
            tick={{ fill: colors.axis, fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip cursor={{ fill: 'transparent' }} content={<BarTooltip total={total} />} />
          <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={16} isAnimationActive>
            {bars.map(b => <Cell key={b.key} fill={b.color} />)}
            <LabelList dataKey="value" position="right" style={{ fill: 'var(--text-1)', fontSize: 12, fontWeight: 700 }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
